// Top-level category hubs that are linked from the homepage, footer, /brands and the directory pages so crawlers
// (and people) reach the category pages in one click. Plain data on purpose: the edge Worker imports it too
// (functions/_lib/directory.js).
//
// `slug` is the category page: /brands/category/{slug}. Indexable brand counts on 2026-10-30 (they include
// sub-categories): apparel 12,575 · home-garden 3,963 · beauty-fitness 3,479 · food-drink 3,434 · health 1,794 ·
// toys-hobbies 1,068 · consumer-electronics 845 · autos-vehicles 505 · sports 487 · computers 450 ·
// pets-animals 302 · books-literature 292.
// Keep only categories with plenty of indexable brands (the edge serves categories under 5 brands as noindex).
export const TOP_CATEGORIES = [
  { slug: "apparel", label: "Apparel" },
  { slug: "home-garden", label: "Home & Garden" },
  { slug: "beauty-fitness", label: "Beauty & Fitness" },
  { slug: "food-drink", label: "Food & Drink" },
  { slug: "health", label: "Health" },
  { slug: "toys-hobbies", label: "Toys & Hobbies" },
  { slug: "consumer-electronics", label: "Consumer Electronics" },
  { slug: "sports", label: "Sports" },
  { slug: "autos-vehicles", label: "Autos & Vehicles" },
  { slug: "computers", label: "Computers" },
  { slug: "pets-animals", label: "Pets & Animals" },
  { slug: "books-literature", label: "Books & Literature" },
];

// A category page is only indexable (and only listed in the sitemap) when it has at least this many brands.
export const MIN_CATEGORY_BRANDS = 20;

export const categoryPath = (slug) => `/brands/category/${slug}`;
